import { MantineProvider } from '@mantine/core';
import { PropsWithChildren } from 'react';
import { createComposableProvider } from 'shared/lib';
import { theme } from 'shared/ui';
import '@mantine/core/styles.layer.css';
import '@mantine/carousel/styles.layer.css';

export const ThemeProvider = ({ children }: PropsWithChildren) => (
	<MantineProvider theme={theme}>{children}</MantineProvider>
);

export const withTheme = createComposableProvider(ThemeProvider);
